import { BaseContainerModel } from '../base-container.model';
import { bl_fi_mst_item_hdr_RowClass, bl_fi_mst_item_hdr_RowInterface } from '../../dbschema/bl_fi_mst_item_hdr.model';
import { bl_t2t_fi_item_to_tenant_link_RowClass, bl_t2t_fi_item_to_tenant_link_RowInterface } from '../../dbschema/bl_t2t_fi_item_to_tenant_link.model';

export class ItemPermissionContainerModel extends BaseContainerModel {
  bl_t2t_fi_item_to_tenant_link: bl_t2t_fi_item_to_tenant_link_RowInterface = new bl_t2t_fi_item_to_tenant_link_RowClass();
}